import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X, Ticket } from "lucide-react";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/entertainment", label: "Lineup" },
  { to: "/tickets", label: "Tickets" },
  { to: "/get-involved", label: "Get Involved" },
  { to: "/faq", label: "FAQ & Venue" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-[#08080c]/95 border-b border-white/10" : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto flex items-center justify-between px-5 md:px-8 h-16 md:h-20">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 group">
          <span className="font-display text-2xl md:text-3xl chromatic leading-none">SPIDER·VERSE</span>
          <span className="font-mono2 text-[9px] tracking-[0.3em] text-[#00f0ff] hidden sm:block">DENVER '26</span>
        </Link>

        <div className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.split(" ")[0].toLowerCase()}`}
              className={`font-head text-sm uppercase tracking-widest transition-colors hover:text-[#00f0ff] ${
                location.pathname === l.to ? "text-[#00f0ff]" : "text-white/80"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <button
            data-testid="nav-buy-tickets-btn"
            onClick={() => navigate("/tickets")}
            className="hidden sm:inline-flex items-center gap-2 bg-[#ff0055] text-white font-head font-bold uppercase text-sm tracking-wider px-5 py-2.5 rounded-full glow-magenta hover:scale-105 active:scale-95 transition-transform"
          >
            <Ticket size={16} /> Get Tickets
          </button>
          <button
            data-testid="nav-mobile-toggle"
            className="lg:hidden text-white p-2"
            onClick={() => setOpen((o) => !o)}
            aria-label="Menu"
          >
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </nav>

      {open && (
        <div className="lg:hidden overflow-hidden bg-[#101018] border-t border-white/10">
          <div className="flex flex-col p-5 gap-4">
            {LINKS.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`nav-mobile-link-${l.label.split(" ")[0].toLowerCase()}`}
                className="font-head uppercase tracking-widest text-white/90 py-1"
              >
                {l.label}
              </Link>
            ))}
            <button
              data-testid="nav-mobile-buy-tickets"
              onClick={() => navigate("/tickets")}
              className="mt-2 bg-[#ff0055] text-white font-head font-bold uppercase px-5 py-3 rounded-full"
            >
              Get Tickets
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
